/* eslint-disable */
import { Button, withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import { ORDERS_PAGE_PATH } from '../../Pages/Orders/Orders.page.route';
import EditProfilePage from '../../Pages/Profile/EditProfile.page';
import { PROFILE_PAGE_PATH } from '../../Pages/Profile/Profile.page.route';
import updateUserProfileActionCreators from '../../State/Store/UserProfile/UserProfile.actions';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import EditProfileDialogPropTypes from './EditProfileDialog.component.props';
import editProfileDialogStyles from './EditProfileDialog.component.styles';

/**
 * Dialog transition
 * @param {string} props the props that are sent
 * @returns {Slide} returns slide component
 * @memberof EditProfileDialogComponent
 */
function Transition(props) {
  return <Slide direction="up" {...props} />;
}

/**
 * EditProfileDialogComponent
 * @export
 * @class EditProfileDialogComponent
 * @extends {React.Component<EditProfileDialogComponentComposedProps, EditProfileDialogComponentState>}
 */
class EditProfileDialogComponent extends React.Component {
  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`ProfileDialog`}
   * @memberof EditProfileDialogComponent
   */
  static displayName = `EditProfileDialog`;

  /**
   * Edit profile `<EditProfileDialogComponent />` instance
   * @type {EditProfileDialogComponent}
   * @memberof EditProfileDialogComponent
   */
  state = {};

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof EditProfileDialogComponent
   */
  static propTypes = EditProfileDialogPropTypes;

  /**
   * Closes the dialog
   * @memberof EditProfileDialogComponent
   * @returns {void} void
   */
  handleClose = () => {
    const { onCloseEditProfileDialog } = this.props;
    if (onCloseEditProfileDialog) {
      onCloseEditProfileDialog();
    }
    return;
  };

  /**
   * Validates email address. This is not used anywhere else at the moment but if needs to be then should be moved to helpers file
   * @memberof EditProfileDialogComponent
   * @returns {void} void
   */
  isValidEmail = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email.trim()) && email.trim().length <= 254; // maximum length of valid email address
  };

  /**
   * Updates the user proifile
   * @memberof EditProfileDialogComponent
   * @returns {void} void
   */
  handleUpdate = async () => {
    const { services, editProfileMessage, actions, firstLogin } = this.props;
    const { userInfo, error } = this.state;
    if (error) {
      editProfileMessage({ autoHideDuration: null, message: `Vailidation error.`, show: true, type: `error` });
    } else {
      try {
        if (!userInfo) {
          editProfileMessage({
            autoHideDuration: 6000,
            message: `Error: First Name, Last Name and either Mobile or Phone number is required`,
            show: true,
            type: `error`,
          });
          return;
        } else if (!userInfo.firstName) {
          editProfileMessage({
            autoHideDuration: 6000,
            message: `Error: Enter a First Name`,
            show: true,
            type: `error`,
          });
          return;
        } else if (!userInfo.lastName) {
          editProfileMessage({
            autoHideDuration: 6000,
            message: `Error: Enter a Last Name`,
            show: true,
            type: `error`,
          });
          return;
        } else if (!this.isValidEmail(userInfo.email)) {
          editProfileMessage({
            autoHideDuration: 6000,
            message: `Error: Email must be a valid email address`,
            show: true,
            type: `error`,
          });
          return;
        } else if (!userInfo.mobilePhone && !userInfo.primaryPhone) {
          editProfileMessage({
            autoHideDuration: 6000,
            message: `Error: Mobile or Phone number is required`,
            show: true,
            type: `error`,
          });
          return;
        }
        await services.userService.updateUserProfile(userInfo);
        this.handleClose();
        if (firstLogin) {
          this.setState({ userProfileComplete: true });
          editProfileMessage({ autoHideDuration: 6000, message: `Your profile has been updated.`, show: true, type: `success` });
        } else {
          editProfileMessage({ autoHideDuration: 6000, message: `Your profile has been updated.`, show: true, type: `success` });
          // Dispatch action to update user profile in state
          actions.updateUserProfile({ profile: userInfo });
        }
      } catch (e) {
        editProfileMessage({ autoHideDuration: null, message: `There has been an error.`, show: true, type: `error` });
      }
    }
    return;
  };

  /**
   * Rediects user to specific page
   * @memberof EditProfileDialogComponent
   * @param {string} pagePath path to redirect user to
   * @returns {void} void
   */
  goToPage = (pagePath) => {
    const { actions, history } = this.props;
    const { userInfo } = this.state;
    actions.updateUserProfile({ profile: userInfo });
    history.push(pagePath);
    return;
  };

  /**
   * Updates the user info in state from edit profile dialog component
   * @memberof EditProfileDialogComponent
   * @param {Object} userInfoToUpdate takes in user info to update object
   * @param {boolean} error the error
   * @returns {void} void
   */
  updatedUserInfo = (userInfoToUpdate, error) => {
    this.setState({ error, userInfo: userInfoToUpdate });
    return;
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<EditProfileDialogComponent />`
   * @memberof EditProfileDialogComponent
   */
  render() {
    const { classes, fullScreen, firstLogin, open, userInfo, location } = this.props;
    const { userProfileComplete } = this.state;

    if (location.pathname === `/logout`) {
      return null;
    }

    let heading = `Edit Profile`;

    if (firstLogin) {
      heading = `Finish Setup`;
    } else if (userProfileComplete) {
      heading = `Welcome ${userInfo.firstName}`;
    }

    return (
      <Grid alignItems="center" container direction="row" justify="center" spacing={3}>
        <Dialog
          aria-labelledby="responsive-dialog-title"
          disableEnforceFocus
          fullScreen={fullScreen}
          onClose={this.handleClose}
          open={open}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <Grid alignItems="center" container spacing={1}>
                {!(firstLogin || userProfileComplete) && (
                  <Grid item>
                    <IconButton aria-label="Close" className={classes.icon} onClick={this.handleClose}>
                      <CloseIcon />
                    </IconButton>
                  </Grid>
                )}
                <Grid className={classes.flexGrow1} item>
                  <Typography className={classes.flex} variant="h6">
                    {heading}
                  </Typography>
                </Grid>

                {!userProfileComplete && (
                  <Grid item>
                    <IconButton onClick={this.handleUpdate}>
                      <DoneIcon />
                    </IconButton>
                  </Grid>
                )}
              </Grid>
            </Toolbar>
          </AppBar>
          <DialogContent>
            {firstLogin && !userProfileComplete && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="body1">Please complete your User Profile before continuing to Boral Connects.</Typography>
                </Grid>
              </Grid>
            )}
            {userProfileComplete ? (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="body1">Your User Profile is complete. You can now start using Boral Connects.</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Button onClick={() => this.goToPage(ORDERS_PAGE_PATH)} variant="contained">
                    GO TO ORDERS
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button onClick={() => this.goToPage(PROFILE_PAGE_PATH)} variant="contained">
                    GO TO PROFILE
                  </Button>
                </Grid>
              </Grid>
            ) : (
              <EditProfilePage firstLogin={firstLogin} onUserInfoChange={this.updatedUserInfo} userInfo={userInfo} />
            )}
          </DialogContent>
        </Dialog>
      </Grid>
    );
  }
}

const EditProfileDialog = compose(
  withStyles(themeCreateInjectableStyles(editProfileDialogStyles), { withTheme: true }),
  withServices,
  withRouter,
  withMobileDialog(),
  connect(null, (dispatch) => ({
    actions: bindActionCreators(
      {
        ...updateUserProfileActionCreators,
      },
      dispatch,
    ),
  })),
)(EditProfileDialogComponent);

export default EditProfileDialog;
